import { useEffect } from "react";

import { IconButton } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";

import { useAdmin } from "./LoggedInAdminProvider";

declare global {
  interface Window {
    fwSettings: any;
    FreshworksWidget: any;
  }
}

export default function SupportWidget(): JSX.Element | null {
  const widgetId = process.env.REACT_APP_FRESKDESK_WIDGET_ID;

  const admin = useAdmin()!;

  useEffect(() => {
    if (!widgetId) {
      return;
    }

    window.fwSettings = { widget_id: widgetId };
    window.FreshworksWidget = (...args: any[]) =>
      window.FreshworksWidget.q.push(args);
    window.FreshworksWidget.q = [];
    window.FreshworksWidget("hide", "launcher");
    window.FreshworksWidget("identify", "ticketForm", {
      name: admin.fullName,
      email: admin.email
    });
    const script = document.createElement("script");
    script.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [admin, widgetId]);

  const handleHelpIconClick = () => {
    window.FreshworksWidget("open");
  };

  if (!widgetId) {
    // Otherwise, display a link to the current documentation
    return (
      <IconButton
        component="a"
        href="https://support.scaletowin.com/"
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
      >
        <HelpOutline />
      </IconButton>
    );
  }
  return (
    <IconButton onClick={handleHelpIconClick} color="inherit">
      <HelpOutline />
    </IconButton>
  );
}
